export default "__VITE_ASSET__ScYD0uw$__"